import { Card, Grid, Group } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import TemplateForm from './TemplateForm';

const TemplatesDetailsForm = ({ template, onSuccess, onBack, del }) => {
  const fetch = useFetch();

  const [userError, setUserError] = useState();
  const { accountId, domainId } = useParams();

  const update = (template, redirect) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/templates/${template.id}`, {
      method: 'PUT',
      body: JSON.stringify(template),
    })
      .then(({ template }) => {
        if (redirect) {
          onSuccess(template);
        } else {
          notifications.show({
            title: 'Layout saved',
            message: 'Your changes have been saved successfully.',
            color: 'success',
          });
        }
      })
      .catch(setUserError);
  };

  if (!template) {
    return <Spinner />;
  }

  return (
    <>
      <Grid>
        <Grid.Col span={{ base: 12, md: 12 }}>
          <Card withBorder>
            <Card.Section inheritPadding py="sm">
              <TemplateForm template={template} saveTemplate={update} deleteTemplate={del} cancel={onBack} />
            </Card.Section>
          </Card>
        </Grid.Col>
      </Grid>
      {userError && (
        <Group justify="flex-end">
          <ErrorMessage message={userError.message} />
        </Group>
      )}
    </>
  );
};

export default TemplatesDetailsForm;
